import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute w-full inset-0 flex flex-col items-start justify-end px-4 md:px-6 xl:px-[71px]" }
const _hoisted_2 = { class: "yeseva-one font-normal text-5xl md:text-[64px] xl:text-8xl text-white z-10 mb-[14px] md:mb-8 xl:mb-10" }
const _hoisted_3 = { class: "relative w-full h-12 xl:h-[60px] shrink-0 mx-auto bg-[#29160E33] rounded-[100px] overflow-hidden border border-[#FFFFFFBF] backdrop-blur-[30px] mb-4 md:mb-6 xl:mb-[26px] z-10" }
const _hoisted_4 = ["placeholder"]

import { useI18n } from "vue-i18n";
import { ref } from "vue";
import blogBg from "@/assets/blog_bg.webp";
import SearchIcon from "@/components/icons/SearchIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogSearch',
  emits: ["search"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const search = ref<string>("");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "overflow-hidden sticky xl:-top-[170px] xl:h-[342px] md:h-[259px] md:-top-[107px] h-[204px] -top-[68px] w-full z-40 bg-cover bg-center transition-all duration-500 ease",
    style: _normalizeStyle({
      backgroundImage: `url(${_unref(blogBg)})`,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute inset-0 bg-mono-brown-gradient" }, null, -1)),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)("blog.search.title")), 1),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          name: "blog-search",
          type: "text",
          autocomplete: "off",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          placeholder: _unref(t)('blog.search.search_placeholder'),
          class: "flex-1 w-full h-full sf-pro font-normal text-sm leading-[21px] md:text-base md:leading-[24px] xl:text-xl xl:leading-[28px] bg-transparent pl-4 py-3 xl:pl-6 xl:py-4 placeholder:text-muted focus:outline-none text-white",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('search', search.value)), ["enter"]))
        }, null, 40, _hoisted_4), [
          [_vModelText, search.value]
        ]),
        _createElementVNode("span", {
          class: "absolute right-[2px] top-[2px] size-[42px] xl:size-[54px] flex items-center justify-center rounded-full bg-orange-gradient transition-transform z-10 hover:cursor-pointer",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('search', search.value)))
        }, [
          _createVNode(SearchIcon)
        ])
      ])
    ])
  ], 4))
}
}

})